function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
import * as customerOrderApi from '@/api/customerOrderApi.js';
import * as toolUtils from '@/utils/toolUtils.js';
import { excelTemplateApi } from '@/api/componentsApi';
import UploadFile from '@/components/Upload/uploadFile.vue';
import { getMiniappList } from '@/api/cardDetailApi';
export default {
  components: {
    UploadFile: UploadFile
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      orderId: null,
      stateMap: [{
        value: 1,
        name: '已下单'
      }, {
        value: 6,
        name: '已确认'
      }, {
        value: 7,
        name: '已生成订单'
      }],
      pram: {},
      appOptions: [] // 小程序选项
    };
  },
  mounted: function mounted() {
    this.getAppList();
  },
  methods: {
    initOpen: function initOpen(orderId) {
      this.orderId = orderId;
      this.pram = {};
      this.visible = true;
    },
    submitImport: function submitImport() {
      var _this = this;
      var _ref = this.pram || {},
        uploadFiles = _ref.uploadFiles;
      if (!uploadFiles) {
        this.$message.warning('请上传文件！');
        return;
      }
      ;
      this.loading = true;
      customerOrderApi.sendBatchMessage(this.orderId, uploadFiles).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    downModal: function () {
      var _downModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return excelTemplateApi('card_password_sms.xlsx');
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = {};
            case 2:
              res = _t;
              toolUtils.downloadFile(res.fileName, '卡密短信模版');
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      function downModal() {
        return _downModal.apply(this, arguments);
      }
      return downModal;
    }(),
    // 获取小程序列表
    getAppList: function () {
      var _getAppList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getMiniappList();
            case 1:
              res = _context2.v;
              if (res && Array.isArray(res)) {
                this.appOptions = res.map(function (item) {
                  return {
                    id: item.id,
                    name: item.appName
                  };
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error('获取小程序列表失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getAppList() {
        return _getAppList.apply(this, arguments);
      }
      return getAppList;
    }()
  }
};